<template>
    <div :class="classes">
        <!-- 审核回退 -->
        <el-dialog
            append-to-body
            :custom-class="prefix"
            center
            @closed="examineForm = {}"
            class="w-photography-examine-dialog"
            :title="backDialogTitle"
            :visible="showBackDialog"
            width="560px"
            :before-close="() => showBackDialog = false">
            <el-form label-width="160px">
                <el-form-item label="回退位置">
                    <el-select v-model="examineForm.back" placeholder="请选择回退位置">
                        <el-option v-for="item in backList" :key="item.key" :label="item.value" :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核备注">
                    <el-input
                        v-model="examineForm.remarks"
                        show-word-limit
                        maxlength="100"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入审核备注">
                    </el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="showBackDialog = false">取 消</el-button>
                <el-button :loading="examining" type="primary" @click="backReview">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 审核对话框 -->
        <el-dialog
            append-to-body
            :custom-class="prefix"
            center
            class="w-photography-examine-dialog"
            :title="examineDialogTitle"
            :visible="showExamineDialog"
            width="560px"
            @closed="examineForm = {}"
            :before-close="() => showExamineDialog = false">
            <el-form label-width="160px">
                <el-form-item label="素材名称">
                    <el-input
                        v-model="examineForm.midName"
                        show-word-limit
                        maxlength="20"
                        placeholder="请输入素材名称">
                    </el-input>
                </el-form-item>

                <el-form-item label="素材类型">
                    <el-select @change="styleChange" v-model="examineForm.style" placeholder="请选择素材类型">
                        <el-option :key="idx" v-for="(item, idx) in styles" :label="item.name" :value="item.type">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="综合评级">
                    <template v-if="grades.length">
                        <div class="p-level-item"
                            v-for="(level, idx) in grades"
                            :key="idx"
                            :class="{ 'p-level-item-active': level.level === examineForm.level }"
                            @click="levelChange(level.level)">
                            <img :src="level.samplePics">
                            <div class="p-level-content">
                                <h3>{{ level.level }}</h3>
                                <div class="p-level-desc">
                                    {{ level.levelStandard }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <span v-else class="p-tips">请选择素材类型</span>
                </el-form-item>

                <el-form-item label="标签">
                    <p class="p-tip">功能标签（请至少选择1个）</p>
                    <div class="p-tag-wrap">
                        <el-cascader
                            :show-all-levels="false"
                            ref="tag"
                            :options="tags"
                            v-model="examineForm.funTags"
                            :props="{ multiple: true }"
                            clearable>
                        </el-cascader>
                    </div>
                    <p class="p-tip">查询标签（请添加素材元素相关的标签，至少1个）</p>
                    <el-popover
                        placement="bottom"
                        title="提示"
                        width="200"
                        trigger="manual"
                        v-model="showTagAddPopover">
                        <div class="p-search-tag-add-popover">
                            <p>是否添加{{ newTag }}标签?</p>
                            <br>
                            <div style="text-align: center">
                                <el-button size="small" @click="cancelTagAdd">取消</el-button>
                                <el-button size="small" type="primary" @click="addTagSearchId">确定添加</el-button>
                            </div>
                        </div>
                        <div slot="reference">
                            <el-select
                                @focus="showTagAddPopover = false"
                                ref="searchTag"
                                no-data-text="无数据,请选择素材类型"
                                @change="currencyTagChange"
                                filterable
                                allow-create
                                multiple
                                default-first-option
                                v-model="examineForm.currencyTag"
                                placeholder="请选择查询标签">
                                <el-option v-for="item in currencyTags" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-popover>
                </el-form-item>

                <el-form-item label="素材格式">
                    <el-select v-model="examineForm.format" placeholder="请选择素材格式">
                        <el-option v-for="format in formats" :key="format" :label="format" :value="format">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否推荐">
                    <el-select v-model="examineForm.is_recommend_js" placeholder="请选择素材格式">
                        <el-option v-for="(val, index) in recommended_list" :key="index" :label="val.label" :value="val.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否与IP相关">
                    <el-radio-group v-model="examineForm.isRelationIp" size="medium">
                        <el-radio-button :label="0" >无关</el-radio-button>
                        <el-radio-button :label="1">相关</el-radio-button>
                    </el-radio-group>

                    <el-select style="margin-top: 10px" v-model="examineForm.ip" placeholder="请选择素材相关的IP" v-if="+examineForm.isRelationIp === 1">
                        <el-option v-for="(item, idx) in ipList" :key="idx" :label="item.name" :value="item.ipId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="审核备注">
                    <el-input
                        v-model="examineForm.remarks"
                        show-word-limit
                        maxlength="100"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入审核备注">
                    </el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="showExamineDialog = false">取 消</el-button>
                <el-button :loading="examining" type="primary" @click="photoworkReviewcheck">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 审核第二步对话框 -->
        <el-dialog
            append-to-body
            :custom-class="prefix"
            center
            class="w-photography-examine-dialog"
            :title="examineDialogTitle"
            :visible="showExamineTwoDialog"
            width="560px"
            @closed="examineTwoForm = { dealType: 1 }"
            :before-close="() => showExamineTwoDialog = false">
            <el-form label-width="160px">
                <el-form-item label="综合评级">
                    <div
                        class="p-level-item p-level-item-active">
                        <img :src="examineTwoForm.samplePics">
                        <div class="p-level-content">
                            <h3>{{ examineTwoForm.level }}</h3>
                            <div class="p-level-desc">
                                {{ examineTwoForm.levelStandard }}
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="结算方式">
                    <el-radio-group class="p-settlement" v-model="examineTwoForm.dealType" v-if="info.midType === 'th_icon'">
                        <el-radio-button key="1" label="1">买断</el-radio-button>
                    </el-radio-group>
                    <span v-if="info.midType === 'th_icon'" class="p-tips">图标类素材仅支持买断</span>
                    <el-radio-group v-model="examineTwoForm.dealType" v-else-if="edit">
                        <el-radio-button :key="type" :label="type" v-for="type in Object.keys(dealType)">{{ dealType[type] }}</el-radio-button>
                    </el-radio-group>
                    <span v-else>{{ dealType[examineTwoForm.dealType] }}</span>
                </el-form-item>

                <el-form-item label="图标数量" v-if="info.midType === 'th_icon'">
                    <el-input-number
                        style="width: 300px"
                        :min="0"
                        placeholder="请选择图标数量"
                        v-model="examineTwoForm.iconNumber">
                    </el-input-number>
                    <span v-if="!edit">* ¥ {{ examineTwoForm.iconSinglePrice }} 元/</span>个
                </el-form-item>

                <el-form-item label="图标单价" v-if="info.midType === 'th_icon' && edit">
                    <el-input-number
                        style="width: 300px"
                        :min="0"
                        :precision="2"
                        placeholder="请选择图标单价"
                        @input="priceChange"
                        v-model="examineTwoForm.iconSinglePrice">
                    </el-input-number>
                    <span>元/个</span>
                </el-form-item>

                <el-form-item label="验收价格" v-if="info.midType === 'th_icon'">
                    <span class="p-tips" v-if="examineTwoForm.iconNumber === '' || examineTwoForm.iconNumber === undefined">请输入图标数量与图标单价</span>
                    <span v-else>￥{{ examineTwoForm.iconSinglePrice * examineTwoForm.iconNumber || 0  }}</span>
                </el-form-item>

                <el-form-item label="验收价格" v-if="+examineTwoForm.dealType === 1 && info.midType !== 'th_icon'">
                    <el-input-number
                        style="width: 300px"
                        v-if="edit"
                        :min="0"
                        :precision="2"
                        placeholder="请选择验收价格,单位(元)"
                        v-model="examineTwoForm.acceptancePrice">
                    </el-input-number>
                    <div v-else>
                        ￥{{ examineTwoForm.acceptancePrice }}
                    </div>
                </el-form-item>

                <el-form-item label="分成比例" v-if="+examineTwoForm.dealType === 2 || +examineTwoForm.dealType === 3">
                    <el-input-number
                        style="width: 300px"
                        v-if="edit"
                        :min="0"
                        :max="100"
                        :precision="0"
                        placeholder="单位(%);普通个人作品默认30%"
                        v-model="examineTwoForm.userSplitRate">
                    </el-input-number>
                    <div v-else>
                        {{ examineTwoForm.userSplitRate }}
                    </div>
                </el-form-item>

                <el-form-item label="预付金" v-if="+examineTwoForm.dealType === 3">
                    <el-input-number
                        style="width: 300px"
                        v-if="edit"
                        :min="0"
                        placeholder="请输入预付金,单位(元)"
                        :precision="2"
                        v-model="examineTwoForm.advancePayment">
                    </el-input-number>
                    <div v-else class="">
                        ￥{{ examineTwoForm.advancePayment }}
                    </div>
                </el-form-item>

                <el-form-item label="奖励金">
                    <el-input-number
                        style="width: 300px"
                        v-if="edit"
                        :min="0"
                        :max="1000"
                        placeholder="单位(元);填0视为无奖励金"
                        :precision="2"
                        v-model="examineTwoForm.rewardMoney">
                    </el-input-number>
                    <div v-else class="">
                        ￥{{ examineTwoForm.rewardMoney }}
                    </div>
                </el-form-item>

                <el-form-item label="修改原因" v-if="+isLevel === 0 && edit">
                    <el-input
                        class="p-comment"
                        v-model="examineTwoForm.changeReason"
                        show-word-limit
                        maxlength="100"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容">
                    </el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button v-if="!isLevel" @click="editClick">{{ edit ? '取消修改' : '修改价格' }}</el-button>
                <el-button :loading="examining" type="primary" @click="photoworkReviewcheckTwoAndThree">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 审核第三步对话框 -->
        <el-dialog
            append-to-body
            center
            class="w-photography-examine-dialog"
            :title="examineDialogTitle"
            :visible="showExamineThreeDialog"
            width="740px"
            @closed="examineTwoForm = { dealType: 1 }"
            :before-close="() => showExamineThreeDialog = false">
            <el-alert class="p-flexible-pricing" :closable="false" :title="flexiblePricingTip" type="info"></el-alert>

            <div class="p-data-wrap">
                <div class="p-data-item p-data-first-item" v-if="+isLevel === 0">
                    <span class="p-label">修改前</span>
                    <el-form label-width="100px">
                        <el-form-item label="综合评级">{{ info.level }}</el-form-item>
                        <el-form-item label="结算方式">{{ dealType[info.dealType] }}</el-form-item>
                        <el-form-item label="验收价格" v-if="+info.dealType === 1">¥{{ currentConfig.acceptancePrice }}</el-form-item>
                        <el-form-item label="分成比例" v-if="+info.dealType === 2 || +info.dealType === 3">{{ currentConfig.userSplitRate }}</el-form-item>
                        <el-form-item label="预付金" v-if="+info.dealType === 3">¥{{ currentConfig.advancePayment }}</el-form-item>
                        <el-form-item label="奖励金">¥ {{ currentConfig.rewardMoney }}</el-form-item>
                        <el-form-item label="是否推荐">{{ currentConfig.isRecommendJs == '1'?'是':'否' }}</el-form-item>
                    </el-form>
                </div>
                <div class="p-data-item p-data-last-item" :class="{ 'w-item-one': +isLevel === 1 }">
                    <span class="p-label" v-if="+isLevel === 0">修改后（可再次修改后审核通过）</span>
                    <el-form label-width="100px">
                        <el-form-item label="结算方式">
                            <el-radio-group class="p-settlement" v-model="examineTwoForm.dealType" v-if="info.midType === 'th_icon'">
                                <el-radio-button key="1" label="1">买断</el-radio-button>
                            </el-radio-group>
                            <el-radio-group v-model="examineTwoForm.dealType" v-else>
                                <el-radio-button :key="type" :label="type" v-for="type in Object.keys(dealType)">{{ dealType[type] }}</el-radio-button>
                            </el-radio-group>
                            <span class="p-tips" v-if="info.midType === 'th_icon'">图标类素材仅支持买断</span>
                        </el-form-item>

                        <el-form-item label="图标数量" v-if="info.midType === 'th_icon'">
                            <el-input-number
                                v-if="edit"
                                style="width: 300px"
                                :min="0"
                                placeholder="请选择图标数量"
                                v-model="examineTwoForm.iconNumber">
                            </el-input-number>
                            <span v-if="edit">*￥{{ examineTwoForm.acceptancePrice }}元/个</span>

                            <span v-if="!edit">
                                <span>{{ examineTwoForm.iconNumber }}</span>个
                                <el-button size="mini" @click="edit = true">修改</el-button>
                            </span>
                        </el-form-item>

                        <el-form-item label="图标单价" v-if="info.midType === 'th_icon'">
                            <el-input-number
                                v-if="edit"
                                style="width: 300px"
                                :min="0"
                                :precision="2"
                                placeholder="请选择图标单价"
                                @input="priceChange"
                                v-model="examineTwoForm.iconSinglePrice">
                            </el-input-number>
                            <span v-if="!edit">{{ examineTwoForm.iconSinglePrice }}</span>
                            <span>元/个</span>
                            <el-button v-if="!edit" size="mini" @click="edit = true">修改</el-button>
                        </el-form-item>

                        <el-form-item label="验收价格" v-if="info.midType === 'th_icon'">
                            <span class="p-tips" v-if="examineTwoForm.iconNumber === '' || examineTwoForm.iconNumber === undefined">请输入图标数量与图标单价</span>
                            <span v-else>￥{{ examineTwoForm.iconSinglePrice * examineTwoForm.iconNumber || 0  }}</span>
                        </el-form-item>

                        <el-form-item label="验收价格" v-if="+examineTwoForm.dealType === 1 && info.midType !== 'th_icon'">
                            <el-input-number
                                style="width: 300px"
                                v-if="edit"
                                :min="0"
                                :precision="2"
                                placeholder="请选择验收价格,单位(元)"
                                v-model="examineTwoForm.acceptancePrice">
                            </el-input-number>
                            <div v-else>
                                ￥{{ examineTwoForm.acceptancePrice }}
                                <el-button size="mini" @click="edit = true">修改</el-button>
                            </div>
                        </el-form-item>

                        <el-form-item label="分成比例" v-if="+examineTwoForm.dealType === 2 || +examineTwoForm.dealType === 3">
                            <el-input-number
                                style="width: 300px"
                                v-if="edit"
                                :min="0"
                                :max="100"
                                :precision="0"
                                placeholder="单位(%);普通个人作品默认30%"
                                v-model="examineTwoForm.userSplitRate">
                            </el-input-number>
                            <div v-else class="">
                                {{ examineTwoForm.userSplitRate }}
                                <el-button size="mini" @click="edit = true">修改</el-button>
                            </div>
                        </el-form-item>

                        <el-form-item label="预付金" v-if="+examineTwoForm.dealType === 3">
                            <el-input-number
                                style="width: 300px"
                                v-if="edit"
                                :min="0"
                                placeholder="请输入预付金,单位(元)"
                                :precision="2"
                                v-model="examineTwoForm.advancePayment">
                            </el-input-number>
                            <div v-else class="">
                                ￥{{ examineTwoForm.advancePayment }}
                                <el-button size="mini" @click="edit = true">修改</el-button>
                            </div>
                        </el-form-item>

                        <el-form-item label="奖励金">
                            <el-input-number
                                style="width: 300px"
                                v-if="edit"
                                :min="0"
                                :max="1000"
                                placeholder="单位(元);填0视为无奖励金"
                                :precision="2"
                                v-model="examineTwoForm.rewardMoney">
                            </el-input-number>
                            <div v-else class="">
                                ￥{{ examineTwoForm.rewardMoney }}
                                <el-button size="mini" @click="edit = true">修改</el-button>
                            </div>
                        </el-form-item>

                        <el-form-item label="是否推荐">
                            <el-select  v-if="edit" v-model="examineTwoForm.is_recommend_js" placeholder="请选择是否推荐">
                                <el-option v-for="(val, index) in recommended_list" :key="index" :label="val.label" :value="val.value">
                                </el-option>
                            </el-select>
                            <div v-else class="">
                                    {{ examineTwoForm.is_recommend_js == '1'?'是':'否'}}
                                <el-button size="mini" @click="edit = true">修改</el-button>
                            </div>
                        </el-form-item>

                        <el-form-item label="修改原因" v-if="+isLevel === 0">
                            {{ info.remark }}
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="showExamineThreeDialog = false">取消</el-button>
                <el-button :loading="examining" @click="photoworkReviewcheckTwoAndThree" type="primary">审核通过</el-button>
            </span>
        </el-dialog>

        <!-- 驳回 -->
        <el-dialog
            append-to-body
            :custom-class="prefix"
            center
            class="p-reject-dialog"
            title="项目验收-审核驳回"
            :visible="showRejectDialog"
            width="560px"
            @closed="rejectForm = {}"
            :before-close="() => showRejectDialog = false">
                <el-form label-width="160px">
                    <el-form-item label="驳回理由">
                        <el-radio-group v-model="rejectForm.reason">
                            <el-radio
                                :key="idx"
                                v-for="(rejectReason, idx) in rejectReasonList"
                                :label="rejectReason.content">
                                {{ rejectReason.content }}
                            </el-radio>
                            <el-radio label="其他">
                                其他理由（请在详细说明中填写）
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input
                            class="p-comment"
                            v-model="rejectForm.comment"
                            show-word-limit
                            maxlength="100"
                            type="textarea"
                            :rows="3"
                            placeholder="请输入内容">
                        </el-input>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="showRejectDialog = false">取 消</el-button>
                    <el-button :loading="examining" type="primary" @click="reviewCheck">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>
<script>
import { forEachTree, FileUtils } from '@/common/utils'
const prefix = "w-photography-examine-operation";
import camelcase from 'camelcase-keys-deep'

export default {
    props: {
        type: {
            type: Number,
            default: 8
        },
        title: {
            type: String,
            default: '摄影投稿'
        },
        info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            prefix,
            // 是否显示审核对话框
            showExamineDialog: false,
            // 审核表单对象
            examineForm: {},
            // 风格列表
            styles: [],
            // 功能标签列表
            tags: [],
            // 查询标签列表
            currencyTags: [],
            // 素材格式列表
            formats: [],

            // 审核第二步对话框
            showExamineTwoDialog: false,
            // 审核第三步对话框
            showExamineThreeDialog: false,
            // 审核第二步表单对象
            examineTwoForm: {
                dealType: 1
            },
            // 审核中
            examining: false,

            // 是否显示驳回对话框
            showRejectDialog: false,
            // 是否显示回退对话框
            showBackDialog: false,

            // 驳回理由列表
            rejectReasonList: [],
            rejectReason: '',

            rejectForm: {},

            edit: true,
            dealType: { 1: '买断', 2: '分成', 3: '预付金+分成' },

            priceConfig: {},
            currentConfig: {},

            ipList: [],
            isLevel: false,

            // 评级列表
            grades: [],

            showTagAddPopover: false,
            newTag: '',
            recommended_list:[
                {label:'否',value:'0'},
                {label:'是',value:'1'}
            ],
        };
    },
    mounted() {
        this.reviewreason()
    },
    methods: {
        priceChange() {
            this.$forceUpdate()
        },
        editClick() {
            this.edit = !this.edit

            if(!this.edit) {
                let { midType, level, dealType } = this.info
                dealType = +dealType === 0 ? 1 : dealType

                if(midType === 'th_icon') {
                    dealType = 1
                }

                Object.assign(
                    this.examineTwoForm,
                    {
                        dealType,
                        ...this.priceConfig[midType][level]
                    }
                )
            }
        },
        levelChange(level) {
            this.$set(this.examineForm, 'level', level)
        },
        async getGrades() {
            let data = await this.api.getProgressPhotoWorklist();
            if(JSON.stringify(data) === '{}') {
                this.$message.error('请设置摄影定价配置')
            }else {
                let config = JSON.parse(data.priceConfig || '{}')
                let newConfig = {}

                Object.keys(config).forEach(key => {
                    newConfig[key] = {}
                    Object.keys(config[key]).forEach(level => {
                        newConfig[key][level] = camelcase(config[key][level])
                    })
                })

                this.priceConfig = newConfig
            }
        },
        async reviewreason() {
            let data = await this.api.reviewreason({ limit: 100, type: 8 })
            this.rejectReasonList = data.data
        },
        async getMidTypes() {
            let data = await this.api.getMidTypes()
            this.styles = data.filter(item => Object.keys(this.priceConfig).includes(item.type))
        },
        async getTagFuncId() {
            let data = await this.api.getTagFuncId()
            this.tags = forEachTree(data, (item) => {
                item.value = item.id
                item.label = item.name
            })
        },
        async getTagSearchId() {
            let data = await this.api.getTagSearchId({
                type: this.examineForm.style,
                material: 1
            })

            this.currencyTags = JSON.stringify(data) === '{}' ? [] : data
        },
        async getMidFormats() {
            this.formats = await this.api.getMidFormats()

            // 审核第一步，素材格式默认勾选
            if(this.info.midIdName) {
                let midIdNameSlice = this.info.midIdName.split('.')
                let suffix = midIdNameSlice.splice(-1)[0]

                if(suffix) {
                    if(suffix === 'jpg') {
                        suffix = 'jpeg'
                    }
                    this.$set(this.examineForm, 'format', suffix)
                }
            }
        },
        async photoworkReviewcheck() {
            let { style, currencyTag, format, remarks, level, midName, isRelationIp, ip,is_recommend_js } = this.examineForm
            let { id, photoId } = this.$route.query
            let tags = this.tag

            if(!id && !photoId) {
                id = this.info.id
                photoId = this.info.photoId
            }

            if(midName === undefined || midName.trim() === '') {
                this.$message.error('请输入素材名称')
            }else if(midName.length > 20) {
                this.$message.error('素材名称最大只能输入20个字')
            }else if(style === undefined) {
                this.$message.error('请选择素材类型')
            }else if(level === undefined) {
                this.$message.error({ message: '请选择综合评级' })
            }else if(tags === '' || tags === undefined || !tags.length) {
                this.$message.error('请选择功能标签')
            }else if(currencyTag === '' || currencyTag === undefined || !currencyTag.length) {
                this.$message.error('请选择查询标签')
            }else if(format === undefined) {
                this.$message.error('请选择素材格式')
            }else if(+isRelationIp === 1 && (ip === undefined || ip === '')) {
                this.$message.error('请选择ip相关')
            }else {
                try {
                    this.examining = true
                    await this.api.photoworkReviewcheck({
                        midType: style,
                        tagFuncId: tags.join(','),
                        tagSearchId: currencyTag.join(','),
                        midFormat: format,
                        remark: remarks,
                        type: this.type, // 固定写死
                        checkStatus: 1, // 固定写死
                        checkSteps: 1, // 固定写死
                        id,
                        photoId,
                        midName,
                        level,
                        isRelationIp,
                        ip,
                        formats: JSON.stringify({
                            '素材名称': midName,
                            '素材类型': this.currentStyleName,
                            '综合评级': level,
                            '功能标签': this.currentTagNames,
                            '查询标签': this.currencyTagNames,
                            '素材格式': format,
                            '是否与IP相关': this.currentIpName,
                            '备注': remarks
                        })
                    })
                    this.showExamineDialog = false
                    this.$message.success('审核通过成功')
                    this.$emit('operationSuccess')


                    //摄影作品设置/取消设置推荐状态
                    await this.api.admin_photowork_setRecommendStatus({
                        photo_id:photoId,
                        status:is_recommend_js?1:0
                    })
                } finally {
                    this.examining = false
                }
            }
        },
        async photoworkReviewcheckTwoAndThree() {
            let { midType, checkSteps } = this.info
            let { acceptancePrice = '', userSplitRate = '', rewardMoney = '', dealType, changeReason = '', iconSinglePrice = '', iconNumber = '',is_recommend_js } = this.examineTwoForm
            if(midType === 'th_icon') {
                acceptancePrice = iconSinglePrice
                iconSinglePrice * iconNumber
            }

            if(acceptancePrice === '' && +dealType === 1) {
                this.$message.error('请输入验收价格')
            }else if (iconSinglePrice === '' && midType === 'th_icon') {
                this.$message.error('请输入图标单价')
            }else if(userSplitRate === '' && +dealType === 2) {
                this.$message.error('请输入分成比例')
            }else if(rewardMoney === '') {
                this.$message.error('请输入奖励金')
            }else if(+checkSteps === 1 && +this.isLevel === 0 && this.edit && changeReason === '') {
                this.$message.error('请输入修改原因')
            }else {
                try {
                    this.examining = true
                    let { id, photoId } = this.$route.query
                    if(!id && !photoId) {
                        id = this.info.id
                        photoId = this.info.photoId
                    }

                    if(+dealType === 1) {
                        userSplitRate = undefined
                    }

                    await this.api.photoworkReviewcheck(Object.assign({
                        type: this.type,
                        checkStatus: 1, // 固定写死
                        checkSteps: +this.info.checkSteps + 1, // 固定写死
                        id,
                        photoId,
                        remark: changeReason,
                        formats: JSON.stringify({
                            '结算方式': this.dealType[dealType],
                            [`${midType === 'th_icon' ? '图标单价' : '验收价格'}`]: acceptancePrice ? `￥${acceptancePrice}` : undefined,
                            '图标数量': iconNumber ? `￥${iconNumber}` : undefined,
                            '分成比例': userSplitRate ? `${userSplitRate}%` : undefined,
                            '奖励金': rewardMoney ? `￥${rewardMoney}` : undefined,
                        }),
                        ...this.examineTwoForm
                    }, acceptancePrice))

                    this.showExamineTwoDialog = false
                    this.showExamineThreeDialog = false
                    this.$message.success('审核通过成功')
                    this.$emit('operationSuccess')


                    if(+checkSteps == 2){
                        //摄影作品设置/取消设置推荐状态
                        await this.api.admin_photowork_setRecommendStatus({
                            photo_id:photoId,
                            status:is_recommend_js
                        })
                    }
                } finally {
                    this.examining = false
                }
            }
        },
        examineDialogClose() {
            this.showExamineDialog = false
        },
        // 审核点击
        async checkClick() {
            this.grades = []
            this.edit = false
            await this.getGrades()
            console.log('审核')
            console.log(this.info.checkStatus)

            // 待审核
            if(+this.info.checkStatus === 0) {
                // 审核第一步
                if(+this.info.checkSteps === 0) {
                    this.getMidTypes()
                    this.getTagFuncId()
                    this.getMidFormats()
                    this.setMidName()
                    this.photoworkIpList()
                    this.showExamineDialog = true
                    // this.examineForm = {}
                    this.$set(this.examineForm, 'isRelationIp', 0)
                    this.$set(this.examineForm, 'is_recommend_js', '0')

                // 审核第二步
                }else if(+this.info.checkSteps === 1 || +this.info.checkSteps === 2) {
                    let { level = '', midType = '', dealType, iconNumber, acceptancePrice, userSplitRate, rewardMoney, iconSinglePrice } = this.info
                    dealType = +dealType === 0 ? 1 : +dealType

                    if(level === '' || midType === '') {
                        this.$message.error('缺少定价设置，请回退到视觉审核1/3')
                        return
                    }

                    this.isLevel = +this.priceConfig[midType].is_level
                    this.edit = Boolean(this.isLevel)

                    if(+this.info.checkSteps === 1) {
                        let { levelStandard, samplePics, acceptancePrice, userSplitRate, rewardMoney, advancePayment } = this.priceConfig[midType][level]

                        this.examineTwoForm = {
                            dealType,
                            level,
                            midType,
                            levelStandard,
                            samplePics,
                            acceptancePrice: '',
                            userSplitRate: '',
                            rewardMoney: '',
                            advancePayment: '',
                            iconSinglePrice: ''
                        }

                        if(+this.isLevel === 0) {
                            Object.assign(this.examineTwoForm, {
                                acceptancePrice, userSplitRate, rewardMoney, advancePayment, iconSinglePrice: acceptancePrice
                            })
                        }

                        this.showExamineTwoDialog = true
                    }else if(+this.info.checkSteps === 2) {
                        let { isRecommend } = this.info
                        this.currentConfig = this.priceConfig[midType][level]
                        this.currentConfig.is_recommend_js = isRecommend

                        this.examineTwoForm = {
                            dealType,
                            acceptancePrice,
                            userSplitRate,
                            rewardMoney,
                            level,
                            midType,
                            iconNumber,
                            iconSinglePrice,
                            is_recommend_js:isRecommend
                        }
                        this.showExamineThreeDialog = true
                    }
                }
            }
        },
        async backReview() {
            let { back, remarks: remark, } = this.examineForm
            let { id, photoId } = this.$route.query
            if(!id && !photoId) {
                id = this.info.id
                photoId = this.info.photoId
            }

            if(back === undefined || back === '') {
                this.$message.error('请选择回退位置')
            }else {
                try {
                    this.examining = true
                    await this.api.reviewCheck8({
                        backward: 1,
                        type: this.type,
                        id,
                        remark,
                        check_status: -3,
                        check_steps: back,
                        formats: JSON.stringify({
                            '回退位置': this.currentBackName,
                            '审核备注': remark
                        })
                    })

                    this.showBackDialog = false
                    this.$emit('operationSuccess')
                } finally {
                    this.examining = false
                }
            }
        },
        async reviewCheck() {
            let { reason, comment } = this.rejectForm
            let { id, photoId } = this.$route.query
            if(!id && !photoId) {
                id = this.info.id
                photoId = this.info.photoId
            }

            if(reason === undefined) {
                this.$message.error('请选择驳回理由')
            }else {
                try {
                    this.examining = true
                    await this.api.reviewCheck8(Object.assign({
                        type: this.type, // 固定写死
                        id,
                        check_status: -1, // 固定写死
                        check_steps: this.info.checkSteps,
                        check_reason: reason,
                        check_comment: comment,
                        formats: JSON.stringify({
                            '驳回理由': reason,
                            '备注': comment
                        })
                    }))

                    this.showRejectDialog = false
                    this.$emit('operationSuccess')
                } finally {
                    this.examining = false
                }
            }
        },
        // 单文件下载
        async download() {
            const fileUtils = new FileUtils(this.info.url, this.info.midIdName)
            await fileUtils.readUrl()
            await fileUtils.download()
        },
        styleChange(val) {
            this.$set(this.examineForm, 'currencyTag', [])

            this.getTagSearchId()

            if(this.priceConfig[val]) {
                this.grades = Object.keys(this.priceConfig[val]).filter(key => key !== 'is_level').map(key => ({ level: key, ...this.priceConfig[val][key] }))
            }else {
                this.grades = []
                this.$message.warning('当前素材类型没有设置评级, 请到【内容-工具箱-业务流程管理】设置')
            }
        },
        cancelTagAdd() {
            let idx = this.examineForm.currencyTag.indexOf(this.newTag)
            ~idx && this.examineForm.currencyTag.splice(idx, 1)

            this.showTagAddPopover = false
        },
        async addTagSearchId() {
            let tags = this.examineForm.currencyTag

            try {
                    await this.api.addTagSearchId({
                        name: this.newTag,
                        type: this.examineForm.style,
                        material: 1
                    })
                    await this.getTagSearchId()

                    const idx = tags.indexOf(this.newTag)
                    const tag = this.currencyTags.find(item => item.name === this.newTag)

                    if(~idx && tag) {
                        tags.splice(idx, 1, tag.id)
                        this.examineForm.currencyTag = tags

                        this.showTagAddPopover = false
                        this.$message.success('标签新增成功')
                    }else {
                        this.$message.error(`新增查询标签失败! 标签列表不存在${this.newTag}`)
                    }
                } catch (error) {
                    this.$message.error(`新增查询标签失败! ${error}`)
                }
        },
        // currencyTags 列表id不能是字符串，否则新增tag会有问题。
        async currencyTagChange(tags) {
            const newTag = tags.find(tagId => !this.currencyTags.find(item => item.id === tagId))
            this.newTag = newTag

            // 新增标签
            if(newTag) {
                this.$nextTick(() => {
                    this.$refs.searchTag.blur()
                    this.showTagAddPopover = true
                })
            }else {
                this.showTagAddPopover = false
            }
        },
        setMidName() {
            if(this.info.photoName) {
                let fileNamePart = this.info.photoName.split('.')

                fileNamePart.splice(-1)
                this.$set(this.examineForm, 'midName', fileNamePart.join(''))
            }
        },
        async photoworkIpList() {
            let data = await this.api.photoworkIpList()
            this.ipList = data
        }
    },
    computed: {
        flexiblePricingTip() {
            return `${this.info.oldPriceCheckName}申请修改该项目验收价格或结算方式，是否审批通过？`
        },
        currentIpName() {
            let photoworkIp = this.ipList.find(item => item.ipId === this.examineForm.ip)

            return (photoworkIp && photoworkIp.name) || ''
        },
        classes() {
            return [prefix];
        },
        examineDialogTitle() {
            return `摄影投稿-审核通过（${+this.info.checkSteps + 1}/3）`
        },
        // 回退列表
        backList(){
            let list = this.allBackList

            return list.slice(0, this.info.checkSteps || 0)
        },
        allBackList() {
            return [
                { key: 0, value: '视觉审核（1/3）' },
                { key: 1, value: '价格确认（2/3）' },
                { key: 2, value: '价格审批（3/3）' },
            ]
        },
        backDialogTitle() {
            let title = ''
            let item = this.allBackList[+this.info.checkSteps]

            if(this.info.checkSteps && item) {
                title = `${this.title}-回退审核-${item.value}`
            }
            return title
        },
        currentStyleName() {
            let style = this.styles.find(item => this.examineForm.style === item.type)

            return style.name
        },
        currentTagNames() {
            return this.$refs.tag.getCheckedNodes(true).map(item => item.label)
        },
        currencyTagNames() {
            return this.currencyTags
                .filter(item => this.examineForm.currencyTag.includes(item.id))
                .map(item => item.name)
        },
        currentBackName() {
            let back = this.backList.find(item => this.examineForm.back === item.key)
            return back.value
        },
        tag() {
            return this.$refs.tag.getCheckedNodes(true).map(item => item.value)
        }
    },
};
</script>

<style lang="scss">
$prefixCls: w-photography-examine-operation;

.#{$prefixCls} {
    .p-tip {
        color: #999;
        font-size: 12px;
    }
    .p-tag-wrap {
        line-height: normal;
    }
    .el-select,.el-cascader,.el-textarea, .el-input {
        width: 300px;
    }
    .p-comment {
        width: 320px;
    }
    .p-tips {
        text-align: center;
        color: #999;
        margin-bottom: 24px;
    }
    .el-cascader__tags {
        max-height: 200px;
        overflow: auto;
    }
}

.w-photography-examine-dialog{
    .p-data-wrap {
        padding: 0 20px;
        display: flex;
        .p-data-item {
            flex: 1;
            color: #333;
            .p-label {
                color: #999;
                margin-bottom: 16px;
                display: inline-block;
            }
            .el-form-item {
                margin-bottom: 0px;
            }
            &.p-data-first-item {
                border-right: 1px solid #efefef;
                margin-right: 40px;
                padding-right: 40px;
            }
            &.p-data-last-item {
                flex: 3;
                .el-form-item {
                    margin-bottom: 22px;
                }
            }
            &.w-item-one {
                text-align: center;
                .el-form {
                    display: inline-block;
                    text-align: left;
                }
            }
        }
    }

    .p-flexible-pricing {
        position: relative;
        margin-top: -27px;
        margin-bottom: 16px;
    }

    .el-dialog__body {
        max-height: 400px;
        overflow-y: auto;
    }
    .p-level-item {
        display: flex;
        margin-bottom: 10px;
        padding-right: 10px;
        border: 1px solid #efefef;
        width: 300px;
        box-sizing: border-box;
        padding: 6px;
        border-radius: 4px;
        cursor: pointer;
        &-active {
            border: 1px solid #33B3FF;
        }
        >img {
            width: 80px;
            height: 80px;
            border-radius: 4px;
        }
        .p-level-content {
            flex: 1;
            line-height: 24px;
            margin-left: 6px;
            h3 {
                color: #33B3FF;
            }
            .p-level-desc {
                color: #999;
                font-size: 12px;
                line-height: 18px;
            }
        }
    }
}
</style>
